import request from '@/utils/request'

// 树
export function getOrganizationTree (query) {
  return request({
    url: '/mdm/business/getOrganizationTree',
    method: 'get',
    params: query
  })
}

// 查询员工列表
export function selectStaffByTeamNo (query) {
  return request({
    url: '/mdm/business/selectStaffByTeamNo',
    method: 'get',
    params: query
  })
}

// 查询数据权限
export function selectTeamDataAuthList (query) {
  return request({
    url: '/mdm/business/selectTeamDataAuthList',
    method: 'get',
    params: query
  })
}
